import { BasketStatus } from '@generated/gql/graphql';

import {
  isCbcInsuranceException,
  isCbcMissingRequirementsException,
  isCbcMultiSIMException,
} from './utils';

const bundleSubmissionValidator = (status: BasketStatus) => {
  const { isValidSelection, unavailableStatuses } = status;

  if (isValidSelection) {
    return { isValid: true, reason: null };
  }

  // This is a valid state, because user is going to fill out cbc reqs in /your-details
  if (isCbcMissingRequirementsException(unavailableStatuses)) {
    return { isValid: true, reason: null };
  }

  // custom `reason` translates multiple API errors into meaningful message
  if (
    isCbcInsuranceException(unavailableStatuses) ||
    isCbcMultiSIMException(unavailableStatuses)
  ) {
    return {
      isValid: false,
      reason: 'To continue, please select one of the core services',
    };
  }

  return { isValid: false, reason: null };
};

export { bundleSubmissionValidator };
